const routes = [
  {
    path: "/perfil",
    name: "Perfiles de Usuario",
    component: () => import("@/views/forms/Perfil.vue"),
  },
  {
    path: "/plan",
    name: "Planes",
    component: () => import("@/views/forms/Plan.vue"),
  },
  {
    path: "/moduplan",
    name: "Módulos por Plan",
    component: () => import("@/views/forms/ModuPlan.vue"),
  },
  {
    path: "/suscripcion",
    name: "Suscripción",
    component: () => import("@/views/forms/Suscripcion.vue"),
  },
  {
    path: "/suscpago",
    name: "Pagos por Suscripción",
    component: () => import("@/views/forms/SuscPago.vue"),
  },
  {
    path: "/tipoiden",
    name: "Tipos de Identificación",
    component: () => import("@/views/forms/TipoIden.vue"),
  },
  {
    path: "/estadocivil",
    name: "Estado Civil",
    component: () => import("@/views/forms/EstadoCivil.vue"),
  },
  {
    path: "/localidad",
    name: "Localidades",
    component: () => import("@/views/forms/Localidad.vue"),
  },
  {
    path: "/asegurador",
    name: "Asegurador",
    component: () => import("@/views/forms/Asegurador.vue"),
  },
  {
    path: "/tipoelem",
    name: "Tipos de Elementos",
    component: () => import("@/views/forms/TipoElem.vue"),
  },
  {
    path: "/claselem",
    name: "Clasificación de Elementos",
    component: () => import("@/views/forms/ClasElem.vue"),
  },
  {
    path: "/elemento",
    name: "Elemento",
    component: () => import("@/views/forms/Elemento.vue"),
  },
  {
    path: "/clasdiag",
    name: "Clasificación de Diagnósticos",
    component: () => import("@/views/forms/ClasDiag.vue"),
  },
  {
    path: "/diagnostico",
    name: "Diagnósticos",
    component: () => import("@/views/forms/Diagnostico.vue"),
  },
  {
    path: "/tipoexamen",
    name: "Tipo de Examen",
    component: () => import("@/views/forms/TipoExamen.vue"),
  },
  {
    path: "/especialidad",
    name: "Especialidad",
    component: () => import("@/views/forms/Especialidad.vue"),
  },
  {
    path: "/persona",
    name: "Personas",
    component: () => import("@/views/forms/Persona.vue"),
  },
  {
    path: "/observacion",
    name: "Observaciones",
    component: () => import("@/views/forms/Observacion.vue"),
    meta: { title: "Observaciones" },
  },
  {
    path: "/respuesta",
    name: "Respuestas",
    component: () => import("@/views/forms/Respuesta.vue"),
    meta: { title: "Respuestas" },
  },  
  {
    path: "/plantilla",
    name: "Plantillas",
    component: () => import("@/views/forms/Plantilla.vue"),
    meta: { title: "Plantilla" },
  },
  
];

export { routes };
